import { render, staticRenderFns } from "./Recommend.vue?vue&type=template&id=251ecfdd&scoped=true"
var script = {}
import style0 from "./Recommend.vue?vue&type=style&index=0&id=251ecfdd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251ecfdd",
  null
  
)

export default component.exports